import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/backgrounds/about-high-res.png'
import _imports_1 from '@/assets/images/backgrounds/about-mobile.png'
import _imports_2 from '@/assets/images/logo/logo-color.svg'


const _hoisted_1 = { class: "section-about" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "about-back hide-mobile",
  src: _imports_0,
  alt: "asset"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "about-back hide-desktop",
  src: _imports_1,
  alt: "asset"
}, null, -1)
const _hoisted_4 = { class: "section-about__content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "logo"
}, null, -1)
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("p", null, _toDisplayString(_ctx.dict.title), 1)
      ]),
      _createElementVNode("p", {
        innerHTML: _ctx.dict.content
      }, null, 8, _hoisted_7)
    ])
  ]))
}